import { render, staticRenderFns } from "./combosmash.vue?vue&type=template&id=6c5d6c1a&"
import script from "./combosmash.vue?vue&type=script&lang=js&"
export * from "./combosmash.vue?vue&type=script&lang=js&"
import style0 from "./combosmash.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6c5d6c1a', component.options)
    } else {
      api.reload('6c5d6c1a', component.options)
    }
    module.hot.accept("./combosmash.vue?vue&type=template&id=6c5d6c1a&", function () {
      api.rerender('6c5d6c1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/work/combosmash.vue"
export default component.exports